<div mdbModal #modal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"
    [config]="{ignoreBackdropClick: true}" (closed)="onClosed()">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title w-100" [translate]="isCheckpoint ? Localization.EditCheckpoint : Localization.EditNodeLabel"></h5>
                <button type="button" class="close pull-right modal-close" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <form *ngIf="formGroup != null" [formGroup]="formGroup">
                    <div class="row mt-4">
                        <div class="col-12">
                            <chapps-text-input [hidden]="isCheckpoint" [label]="Localization.Label" [isRequired]="!isCheckpoint"
                                [control]="labelFormControl">
                            </chapps-text-input>
                            <div class="mt-2">
                                <chapps-text-area-input [label]="Localization.Comment" [control]="commentFormControl">
                                </chapps-text-area-input>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="multimedia-container" *ngIf="model && model.multimedia">
                    <chapps-multimedium *ngFor="let multimedium of model.multimedia; index as i" class="mr-2 mb-2"
                        [model]="multimedium" [showDate]="true" [dateFormat]="config.DATE_FORMAT" [deletable]="true"
                        (clicked)="openMediaInMultimediaViewer(i)"
                        (deleted)="openDeleteMediaConfirmationPopup(multimedium.id)"></chapps-multimedium>
                    <chapps-multimedia-selector
                        [disableVideoUpload]="false"
                        [disableDocumentUpload]="false"
                        [loading]="isMediaAdding"
                        (videoSubmitted)="onVideoSubmitted($event)"
                        (imageSubmitted)="onImageSubmitted($event)"
                        (documentSubmitted)="onDocumentSubmitted($event)">
                    </chapps-multimedia-selector>
                </div>
            </div>
            <div class="modal-footer justify-content-end">
                <chapps-secondary-button [label]="Localization.Submit" [small]="true" (clicked)="onSubmit()">
                </chapps-secondary-button>
            </div>
        </div>
    </div>
</div>
<app-delete-confirm-modal (delete)="deleteMedia($event)"></app-delete-confirm-modal>
